import { useMutation } from '@tanstack/react-query';
import { api } from '@/shared/axios-client';

export interface InstrumentationBody {
  azure_org: string;
  azure_project: string;
  pipeline_name: string;
  repo_url: string;
  target_branch: string;
  reviewers: string[];
  backend_project: string;
  /** Mongo repositories._id for the app repo */
  repo_id?: string;
  /** Where to store PR status on the app repo document */
  instrumentation_target?: 'app' | 'test';
}

export interface InstrumentationResponse {
  job_id: string;
  status: string;
  message?: string;
}

export const postInstrumentation = (
  body: InstrumentationBody,
  patToken: string,
): Promise<InstrumentationResponse> =>
  api.post('/api/instrumentation/async', body, {
    headers: {
      'Requester-Token': patToken,
      'Content-Type': 'application/json',
    },
  });

export const usePostInstrumentation = (patToken: string) =>
  useMutation({
    mutationFn: (body: InstrumentationBody) =>
      postInstrumentation(body, patToken),
  });
